import { db } from "../../index";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import {startLoading, stopLoading} from "../loader";

export async function createVehicle(userInfos, vehicle) {
    startLoading();

    let snap = await db.ref(`users/${userInfos.uid}/vehicle`).push(vehicle);
    snap = await db
        .ref(`users/${userInfos.uid}/vehicle/${snap.key}`)
        .update({ id: snap.key });

    stopLoading();

    return snap;
}

export async function updateVehicle(userInfos, vehicle) {
    startLoading();

    await db.ref(`users/${userInfos.uid}/vehicle/${vehicle.id}`).update(vehicle);

    stopLoading();
}

export async function deleteVehicle(userInfos, vehicle_id) {
    if (!Array.isArray(vehicle_id)) {
        vehicle_id = [vehicle_id];
    }

    startLoading();

    let pList = vehicle_id.map(async (id) => {
        if (id) await db.ref(`users/${userInfos.uid}/vehicle/${id}`).remove();
    });

    await Promise.all(pList);

    stopLoading();
}

export function useVehicles() {
    const { userInfos } = useContext(UserContext);
    const [vehicles, setVehicles] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        db.ref("users/" + userInfos.uid + "/vehicle")
            .once("value")
            .then((snapshot) => {
                let res = [];
                snapshot.forEach(function (childSnapshot) {
                    res.push({
                        id: childSnapshot.key,
                        ...childSnapshot.val(),
                    });
                });
                setVehicles(res);
                setLoaded(true);
            });
    }, [userInfos.uid]);

    return { vehicles, loaded };
}
